import { useMemo } from 'react';
import { DefaultTheme } from '@mui/styles';

type CommonChartStyles = {
  Labels: {
    fontSize: number | string | undefined;
    fontFamily: string | undefined;
  };
};

export const useCommonChartStyles = (
  theme: DefaultTheme
): CommonChartStyles => {
  return useMemo(
    () => ({
      Labels: {
        fontSize: theme.typography.body2.fontSize,
        fontFamily: theme.typography.body2.fontFamily
      }
    }),
    [theme]
  );
};
